export * from './NodeEnv';

export const KEY = 'shopping-bag-provider';

export const putRequestOptions = {
  method: 'PUT',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- predefined HTTP header name
  headers: { 'Content-Type': 'application/json' },
};

/**
 * Identity server client ID for local (development-time) authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';

export const ANONYMOUS_CUSTOMER_ID = -1;
